






















import { Component, Vue, Prop } from 'vue-property-decorator'

type InputTextType = 'text' | 'textarea'

@Component({})
export default class InputText extends Vue {
  @Prop({ required: true, default: '' }) private id!: string
  @Prop({ required: true, default: 'text' }) private type!: InputTextType
  @Prop({ required: true, default: null }) private value!: string | null
  @Prop({ required: true, default: false }) private hasError!: boolean

  private get localText() {
    return this.value || ''
  }

  private set localText(v: string) {
    this.$emit('input', v)
  }

  private get inputTextTypeByText() {
    return 'text'
  }
}
